import { IPropsWithChildren } from '@omaze/app';
import classNames from 'classnames';
import React, {
    ReactElement,
    useState,
    useEffect,
    SetStateAction,
    Dispatch,
} from 'react';

import { COLLAPSE_QA, collapseDisplayName } from './Collapse.qa';

export interface ICollapseProps extends IPropsWithChildren {
    'data-testid'?: string;
    className?: string;
    expanded?: boolean;
}

export function OzCollapse (props: ICollapseProps): ReactElement {
    const {
        children,
        className = '',
        expanded = false,
    }: ICollapseProps = props;

    const [childrenVisible, setChildrenVisible]: [
        boolean,
        Dispatch<SetStateAction<boolean>>
    ] = useState<boolean>(false);

    useEffect((): void => {
        /**
         * Update the visibility state of the children elements when "expanded" prop is toggled after a set delay
         * This supplements the CSS animation which transitions the opacity
         */
        if (expanded !== childrenVisible) {
            if (expanded) {
                setChildrenVisible(true);
            } else {
                setChildrenVisible(false);
            }
        }
    }, [expanded, childrenVisible]);

    return (
        <div
            className={classNames({
                'transition-opacity opacity-100 duration-500 ease-linear': true,
                'opacity-00': !expanded,
                'opacity-100': !!expanded,
                [className + '']: !!className,
            })}
            data-testid={COLLAPSE_QA.CONTAINER}
        >
            {childrenVisible && children}
        </div>
    );
}

OzCollapse.displayName = collapseDisplayName;
